import { render, staticRenderFns } from "./ParcoursContentBuilder.vue?vue&type=template&id=64f4cc80&scoped=true&"
import script from "./ParcoursContentBuilder.vue?vue&type=script&lang=js&"
export * from "./ParcoursContentBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f4cc80",
  null
  
)

export default component.exports